import {animate, state, style, transition, trigger} from '@angular/animations';
import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';
import {MxButtonModel} from '../../mx-button/components/mx-button.model';
import {MxPreloaderService, PreloaderState, PreloaderType} from '../services/mx-preloader.service';

@Component({
    selector: 'mx-preloader',
    standalone: false,
    templateUrl: './mx-preloader.component.html',
    styleUrls: ['./mx-preloader.component.scss'],
    animations: [
        trigger('animateOpacity', [
            transition(':leave', [
                animate(300, style({opacity: 0}))
            ]),
            state('*', style({opacity: 1})),
            state('None', style({opacity: 0})),
        ])
    ]
})

export class MxPreloaderComponent implements OnInit, OnDestroy {

    @Input()
    preloaderName: string = 'root';
    @Input()
    type: PreloaderType = 'None';

    private _destroy$$: Subject<null> = new Subject<null>();
    public state: PreloaderState;
    cancelButton: MxButtonModel;

    constructor(
        private preloaderService: MxPreloaderService,
        private cdRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.state = {
            type: this.type,
            cancelEvent: undefined,
            preloaderName: this.preloaderName
        };
        this.cancelButton = {
            label: 'Cancel',
            tooltip: 'Cancel',
            className: 'mxs-button--secondary',
            hidden: () => !this.state.cancelEvent,
            clickHandler: () => {
                if (this.state.cancelEvent != null) {
                    this.state.cancelEvent();
                }
            }
        };
        this.preloaderService.getPreloaderState()
            .pipe(
                takeUntil(this._destroy$$),
                filter(preloaderState => {
                    return preloaderState.preloaderName === this.preloaderName && this.state.type !== preloaderState.type;
                })
            ).subscribe((preloaderState: PreloaderState) => {
            this.state = {...preloaderState};
            this.cdRef.detectChanges();
        });
    }

    ngOnDestroy(): void {
        this._destroy$$.next(null);
    }

}
